import config from "../config";
import http from "../http";
import qs from 'qs'

/**
 * @author ccjmkj
 */
export default {
    //获取折扣商品列表
    getDiscountList:async function(payload){
        const res= await http({
            url:config.GET_DISCOUNT_LIST,
            method:'post',
            data: {
                discount_status: payload.discount_status,
                pagination_entries_per_page: payload.pagination_entries_per_page,
                pagination_offset: payload.pagination_offset,
                shopid: payload.shopid,
                update_time_from: payload.update_time_from,
                update_time_to: payload.update_time_to
            },
            config:{
                accessToken : payload.accessToken
            }
        })
        return res.data
    },
    /**
     * 添加折扣商品
     * @param payload
     * @returns {Promise<*>}
     */
    addDiscountItem:async function(payload){
        const res= await http({
            url:config.ADD_DISCOUNT,
            method: 'post',
            data:{
                discount_name:payload.discount_name,
                start_time:payload.start_time,
                end_time:payload.end_time,
                shopid:payload.shopid,
                items:payload.items
            }
        })
        return res.data
    },
    /**
     * 添加自动活动续期商品
     * @param payload
     * @returns {Promise<*>}
     */
    addAutoDiscount:async function(payload){
        const res = await http({
            url:config.MONITOR_AUTO_DISCOUNT,
            method:'post',
            data:{
                ...payload
            }
        })
        return res.data
    },
    /**
     * 获取用户商品商品详细信息
     */
    getAccountItemsList:async function(payload){
        const res = await http({
            url:config.GET_ACCOUNT_ITEMS,
            method:'post',
            data: {
                ...payload
            },
            headers:{
                'Content-Type':'application/json'
            }
        })
        return res.data
    },
    /**
     *监控商品的URL
     */
    monitoringGoods:async function(payload){
        const res = await http({
            url:config.MONITORING_GOODS,
            method:'get',
            data:{
                url:payload
            },
        })
        return res.data;
    },
    /**
     * 绑定用户商品跟页面的model
     */
     bindAccountItem2model:async function(payload){
         const res = await http({
             url:config.BIND_ACCOUNT_ITEM_2_MODEL,
             method:'post',
             data: payload
         })
        return res.data
    },
     getShopMonitorInfo:async function(payload){
         const res = await http({
             url:config.GET_SHOP_MONITOR_INFO,
             method:'post',
             data:{
                 ...payload
             }
         })
        return res.data
    },
    /**
     * 获取监控规则
     */
    getMonitorRules:async function(payload){
        const res = await http({
            url:config.GET_MONITOR_RULES,
            method:'get',
            data:{

            }
        })
        return res.data
    },
    /**
     * 解绑监控绑定
     */
    unbindModelAndItem:async function(payload){
        const res = await http({
            url:config.UNBIND_MODEL_AND_ITEM,
            method:"post",
            data: payload
        })
        return res.data
    },

    updateMonitorRule:async function(payload){
        const res = await http({
            url:config.UPDATE_MONITOR_RULE,
            method:"post",
            data: payload,
        })
        return res.data
    }


}